// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"88f32106","145":"d11f5d79","191":"f8a564da","866":"1329db29"}[chunkId] + ".chunk.css";
};